import type { Analysis } from '../models/card-model';
import { formatAnalysisTitle } from './analysis-datetime.util';

/**
 * Period name for pickers and navigation (dropdown, dots, delete confirm).
 * Prefer explicit `label`, then calendar period, then headline.
 */
export function getAnalysisPickerLabel(
	period: Analysis,
	index: number
): string {
	if (period.label?.trim()) {
		return period.label.trim();
	}
	const range = formatAnalysisTitle(
		period.startTimestamp,
		period.endTimestamp
	);
	if (range) {
		return range;
	}
	const headline = period.headline?.trim();
	if (headline) {
		return headline;
	}
	return `Analysis ${index + 1}`;
}

/** Placeholder for the period label field when `label` is unset. */
export function getAnalysisPickerPlaceholder(
	period: Analysis,
	index: number
): string {
	const range = formatAnalysisTitle(
		period.startTimestamp,
		period.endTimestamp
	);
	if (range) {
		return range;
	}
	return `Analysis ${index + 1}`;
}
